import React from "react";

import Profile from "@/assets/icon/user.svg";

import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

import { logoutUser } from "@/services/rest/user-logout";

import Icon from "@/components/units/Icon";
import { useNotification } from "@/libraries/notification/NotificationContext"
import { NOTIFICATION } from "@/constants"

import { navigateToTab } from "@/utility/navigate"

interface Data {
  label: string;
  icon: string;
  path: string;
  isEnabled: boolean;
  action: Function;
}

interface SidebarTabProps {
  data: Data;
  currTab: string;
  handleTabChange: (tab: string) => void;
}

const SidebarTab: React.FC<SidebarTabProps> = ({
  data,
  currTab,
  handleTabChange,
}) => {
  const { sendNotification:sendToast } = useNotification(NOTIFICATION.TOAST);

  const stopRedirection = (e: any) => {
    if(data.isEnabled){
      if(data.action){
        data.action()
        e.preventDefault();
      }
    } else {
      sendToast("Coming soon")
      e.preventDefault();
    }
  };

  return (
    <NavLink
      to={`/account/${data.path}`}
      className={({ isActive }) => isActive && "tw-bg-[#E6F3FB]"}
      onClick={stopRedirection}
    >
      <div
        className={`tw-p-4 tw-bg-inherit tw-border-b tw-border-b-[#F2F2F2] last:tw-border-b-0 tw-flex tw-justify-between tw-items-center tw-cursor-pointer`}
        // TODO: uncomment when other tabs designs are available
        // onClick={() => handleTabChange(data.label)}
      >
        <div className="tw-flex tw-gap-3">
          <div>
            <Icon
              iconName={data.icon}
              wrapperStyle="tw-flex-grow-0 tw-box-content tw-text-primaryBlack"
            >
              <></>
            </Icon>
          </div>
          <div>{data.label}</div>
        </div>
        <div>
          <Icon
            iconName={"right-icon"}
            wrapperStyle="tw-flex-grow-0 tw-box-content tw-text-primaryBlack"
          >
            <></>
          </Icon>
        </div>
      </div>
    </NavLink>
  );
};

interface SidebarProps {
  currTab: string;
  handleTabChange: (tab: string) => void;
}

const AccountSidebar: React.FC<SidebarProps> = ({
  currTab,
  handleTabChange,
}) => {


  const { sendNotification: sendToast } = useNotification(NOTIFICATION.TOAST);
  const isMobile = useSelector((state: any) => state.global.device.below.sm);
  const userData = useSelector((state: any) => state.user.user);

  const sidebarTabs = [
    { id: 1, label: "Profile", path: "profile", isEnabled: true, icon: "user" },
    {
      id: 2,
      label: "Refer & Earn",
      path: "refer-and-earn",
      isEnabled: false,
      icon: "refer",
    },
    {
      id: 3,
      label: "Settings",
      path: "settings",
      isEnabled: false,
      icon: "settings",
    },
    {
      id: 4,
      label: "About Us",
      action: ()=>navigateToTab(import.meta.env.VITE_TDWEBSITE_BASE + "/about-us"),
      isEnabled: true,
      icon: "about-us",
    },
    {
      id: 5,
      label: "Support",
      action: ()=>navigateToTab(import.meta.env.VITE_TDWEBSITE_BASE + "/contact-us"),
      isEnabled: true,
      icon: "customer-support",
    },
    {
      id: 6,
      action: logoutUser,
      label: "Logout",
      isEnabled: true,
      icon: "logout",
    },
  ];

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      sendToast("Client ID Copied!")
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };
  return (
    <div
      className={`tw-bg-white tw-rounded-[6px] tw-h-[427px] ${
        isMobile ? "tw-w-full" : "tw-w-[320px]"
      }`}
      style={{ boxShadow: "0px 0px 11px -2px #A7A7A733" }}
    >
      <div className="tw-p-4 tw-flex tw-gap-4 tw-items-center">
        <div>
          <img src={Profile} className="tw-w-9 max-lg:tw-w-6"/>
        </div>
        <div>
          {userData?.firstName && (
            <div className="tw-text-[16px] tw-text-primaryBlack tw-font-nmmed tw-mb-1 tw-capitalize">
              Hey, {userData?.firstName.toLowerCase()}
            </div>
          )}
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed tw-text-opacity-80 tw-flex tw-gap-2 max-lg:tw-text-[12px]" >
            Client ID: {userData?.uniqueCientCode}

            <Icon iconName="copy-icon" wrapperStyle="tw-cursor-pointer max-lg:tw-w-3" onClick={() => handleCopy(userData?.uniqueCientCode)}/>
          </div>
        </div>
      </div>
      <div className="">
        {sidebarTabs.map((tab) => (
          <SidebarTab
            key={tab.id}
            data={tab}
            handleTabChange={handleTabChange}
            currTab={currTab}
          />
        ))}
      </div>
    </div>
  );
};

export default AccountSidebar;
